import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import Small from 'UIComponents/elements/Small';
import { useLimit } from 'automation-ui-core/hooks/authHooks';
import { WEBHOOK_TRIGGER_EVENT_LIMIT_NAME, DEFAULT_WEBHOOK_TRIGGER_EVENT_LIMIT } from 'automation-ui-enrollment/constants/WebhookLimits';
import WebhookEventsDescription from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookEventsDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookTriggersEmptyState = ({
  setShowWizard
}) => {
  const portalWebhookLimit = useLimit(WEBHOOK_TRIGGER_EVENT_LIMIT_NAME);
  const webhookLimit = Number.isFinite(portalWebhookLimit) ? portalWebhookLimit : DEFAULT_WEBHOOK_TRIGGER_EVENT_LIMIT;
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "column",
    align: "center",
    className: "text-center",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(WebhookEventsDescription, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.events.webhookEvents.noWebhooks.allObjectsEmptyState"
        })
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary",
        size: "small",
        onClick: () => setShowWizard(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.events.webhookEvents.addNewWebhook"
        })
      })
    }), /*#__PURE__*/_jsx(Small, {
      tagName: "p",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "automation-ui-enrollment.redesign.events.webhookEvents.noWebhooks.limitInfo",
        options: {
          maxCount: webhookLimit
        }
      })
    })]
  });
};
export default WebhookTriggersEmptyState;